module.exports = __webpack_public_path__ + "img/INFJ.6c6adc02.png";